import { useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const NavbarSlider = ({
  slides,
  title = '',
  titleColor = 'text-primary-text',
  buttonTextColor = 'text-primary',
  buttonBorderColor = 'border-primary',
  slideClassName = 'mr-2',
  showButton = true,
}: {
  slides: React.ReactNode[];
  title?: string;
  titleColor?: string;
  slideClassName?: string;
  showButton?: boolean;
  buttonBorderColor?: string;
  buttonTextColor?: string;
}) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    const container = scrollRef.current;
    if (container) {
      const scrollAmount = container.offsetWidth / 1.5;
      container.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="relative flex flex-col md:gap-4 max-w-screen-xl w-full">
      <div className="flex justify-between">
        <div className={`text-[30px] font-semibold ${titleColor}`}>{title}</div>
      </div>

      <div className="relative flex items-center">
        {showButton && (
          <button
            onClick={() => scroll('left')}
            className={`flex-shrink-0 md:mx-4 lg:mx-0 border ${buttonBorderColor} rounded-full size-6 lg:size-8 flex items-center justify-center ${buttonTextColor} z-10`}
            aria-label="Scroll Left"
          >
            <ChevronLeft className="size-6" />
          </button>
        )}

        <div
          ref={scrollRef}
          className={`flex gap-1 md:gap-2.5 overflow-x-auto hide-scrollbar w-full ${slideClassName}`}
        >
          {slides?.map((slide, index) => (
            <div key={`${slide}-${index}`} className="w-auto min-w-max px-1 md:px-2.5">
              {slide}
            </div>
          ))}
        </div>

        {showButton && (
          <button
            onClick={() => scroll('right')}
            className={`flex-shrink-0 md:mx-4 border ${buttonBorderColor} size-6 lg:size-8 flex items-center justify-center rounded-full ${buttonTextColor} z-10`}
            aria-label="Scroll Right"
          >
            <ChevronRight className="size-6" />
          </button>
        )}
      </div>
    </div>
  );
};

export default NavbarSlider;
